import React from 'react';
import {
    Page,
    Text,
    Columns,
    Layout,
} from '@shopify/polaris';
import { useHistory } from "react-router-dom";
import BulkOperationCard from './BulkOperationCard';
import { Helmet } from 'react-helmet';

function OperationsNewPage() {

    const history = useHistory();
    const navigateTo = (url) => {
        history.push(url);
    };

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Create Bulk Tag Operation</title>
            </Helmet>
            <Page title="Create Bulk Operation"
                breadcrumbs={[{ content: 'Bulk Operations', url: '/operations' }]}>
                <Layout>
                    <Layout.Section>
                        <Text variant="headingLg" as="h2" alignment="center">Choose Tag Operation</Text>
                        <br />
                        <Columns
                            columns={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }}
                            gap={{
                                xs: '4',
                                md: '4',
                            }}>
                            <BulkOperationCard
                                title="Bulk Remove Tags"
                                description="Quickly bulk remove products tags using visual tools."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-remove.png"
                                onCreate={() => navigateTo("/operations/new/remove")} />
                            <BulkOperationCard
                                title="Bulk Merge/Rename Tags"
                                description="Quickly merge multiple tags into a single tag or simply rename tags."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-merge.png"
                                onCreate={() => navigateTo("/operations/new/merge")} />
                            <BulkOperationCard
                                title="Change Prefix of Tags"
                                description="Quickly change prefix of tags. Optionally keep old tags."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-custom.png"
                                onCreate={() => navigateTo("/operations/new/change-prefix")} />
                            <BulkOperationCard
                                title="Fix Tag Capitalization"
                                description="Fix/Change capitalization of tag names."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-change-capitalization.png"
                                onCreate={() => navigateTo("/scenarios/fix-capitalization")} />
                            <BulkOperationCard
                                title="Tag Text Replacement"
                                description="Replace specified characters or words in your tags."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-text-replacement.png"
                                onCreate={() => navigateTo("/scenarios/text-replacement")} />
                            <BulkOperationCard
                                title="Custom Tag Operation"
                                description="Advanced filtering and complex operations for custom scenarios."
                                imageSrc="https://taggeniemain.blob.core.windows.net/images/app-scenarios-custom.png"
                                onCreate={() => navigateTo("/operations/new/custom")} />

                        </Columns>
                    </Layout.Section>
                </Layout>
            </Page>
        </div >
    );
}

export default OperationsNewPage;